/**
 * Returns `value` when it is neither `null` nor `undefined`, and throws otherwise.
 *
 * Used where code dereferences a value that the types declare optional but the flow expects present:
 * the absence already threw a `TypeError` at that point, this keeps the throw and names what was missing.
 */
export function requireDefined<T>(value: T | null | undefined, description: string): T {
  if (value === null || value === undefined) {
    throw new Error(`Expected ${description} to be defined`)
  }
  return value
}
